import React from 'react'
import PageLayout from '../../../components/organismes/PageLayout/PageLayout'
import NewSpendingDemandForm from '../../../features/spendingDemand/components/NewSpendingDemandForm/NewSpendingDemandForm'

export default function NewSpendingDemandPage() {

  return (
    <PageLayout 
      title="Nouvelle demande de dépense"
      showBackButton
      backButtonLinkToIfNoHistory="/spending_demand"
    >
      <NewSpendingDemandForm />
     <div>
   
     </div>
    </PageLayout>
  )
  
}
